export const INITIAL_EMPLOYEES = [
  {
    id: "EMP-001",
    name: "Narayan Rao Hegde",
    role: "Owner / Admin",
    phone: "+91 98490 88990",
    email: "narayan.hegde@kiranastore.com",
    monthlySalary: 125000,
    assignedLocation: "Kattedan Industrial Mega Hub (WH-001)",
    advanceTaken: 0,
    joinDate: "2020-01-15",
    status: "Active"
  },
  {
    id: "EMP-002",
    name: "Venkateshwar Reddy",
    role: "Warehouse Manager",
    phone: "+91 98490 11220",
    email: "venkat.reddy@kiranastore.com",
    monthlySalary: 45000,
    assignedLocation: "Kattedan Industrial Mega Hub (WH-001)",
    advanceTaken: 5000,
    joinDate: "2021-04-10",
    status: "Active"
  },
  {
    id: "EMP-003",
    name: "Srinivas Rao",
    role: "Warehouse Manager",
    phone: "+91 98490 33440",
    email: "srinivas.rao@kiranastore.com",
    monthlySalary: 42000,
    assignedLocation: "Begum Bazar Central Distribution Depot (WH-002)",
    advanceTaken: 0,
    joinDate: "2021-08-20",
    status: "Active"
  },
  {
    id: "EMP-004",
    name: "Vikas Goud",
    role: "Warehouse Staff",
    phone: "+91 98490 44550",
    email: "vikas.goud@kiranastore.com",
    monthlySalary: 22000,
    assignedLocation: "Kattedan Industrial Mega Hub (WH-001)",
    advanceTaken: 2000,
    joinDate: "2022-03-01",
    status: "Active"
  },
  {
    id: "EMP-005",
    name: "Rameshwar Goud",
    role: "Sales Team",
    phone: "+91 98490 55660",
    email: "rameshwar.sales@kiranastore.com",
    monthlySalary: 32000,
    assignedLocation: "Begum Bazar Mandi Desk (WH-002)",
    advanceTaken: 0,
    joinDate: "2022-07-15",
    status: "Active"
  },
  {
    id: "EMP-006",
    name: "Swathi Kulkarni",
    role: "Accountant / Finance",
    phone: "+91 98490 66770",
    email: "swathi.finance@kiranastore.com",
    monthlySalary: 38000,
    assignedLocation: "Abids Head Office, Hyderabad",
    advanceTaken: 0,
    joinDate: "2021-11-10",
    status: "Active"
  },
  {
    id: "EMP-007",
    name: "Anand Deshmukh",
    role: "Retail Shop Staff",
    phone: "+91 98490 77880",
    email: "anand.retail@kiranastore.com",
    monthlySalary: 24000,
    assignedLocation: "Kukatpally Express Retail Godown (WH-003)",
    advanceTaken: 1500,
    joinDate: "2023-01-05",
    status: "Active"
  }
];

export const initialEmployees = INITIAL_EMPLOYEES;

